export default {
    no: "nb",
} as { [locale: string]: string };
